<template>
    <CellPopover
        v-if="enabled"
        ref="popover"
        title="Team chat"
        :label="`Team chat: ${count} unread ${count === 1 ? 'conversation' : 'conversations'}`"
        trigger-tag="button"
        trigger-class="chat-notifications-trigger"
        :trigger-attrs="{
            title: `Team chat: ${count} unread ${count === 1 ? 'conversation' : 'conversations'}`
        }"
        :min-width="280"
        :max-width="360"
        align="end"
    >
        <template #trigger>
            <i class="far fa-comments" aria-hidden="true"></i>
            <span v-if="count" class="chat-badge" aria-hidden="true">{{
                count > 99 ? "99+" : count
            }}</span>
        </template>
        <Notice v-if="query.isError.value" danger
            >Chat notifications could not be refreshed.</Notice
        >
        <p v-else-if="query.isPending.value" class="p-2 mb-0">Loading chats…</p>
        <p v-else-if="!count" class="p-2 mb-0">You’re all caught up.</p>
        <router-link
            v-for="row in unread"
            :key="row.group_id"
            :to="{
                path: '/chat',
                query: { group: row.group_id, ...(row.mention ? { message: row.mention.id } : {}) }
            }"
            class="chat-alert-row"
            @click="openChat"
        >
            <strong
                >{{ row.name
                }}<i v-if="row.state.muted" class="fas fa-bell-slash ms-2" title="Muted"></i
            ></strong>
            <span v-if="row.mention" class="chat-alert-mention"
                >@ {{ row.mention.sender_name }} mentioned you</span
            >
            <span>{{ row.latest.sender_name }}: {{ row.latest.body }}</span>
        </router-link>
        <router-link class="chat-alert-row" to="/chat" @click="openChat"
            >Open team chat</router-link
        >
    </CellPopover>
</template>

<script setup>
import { ref } from "vue";
import CellPopover from "@/components/common/CellPopover.vue";
import Notice from "@/components/common/Notice.vue";
import { useChatSummary } from "@/composables/queries/useChat";
const emit = defineEmits(["navigate"]);
const popover = ref(null);
function openChat() {
    popover.value?.close();
    emit("navigate");
}
const { query, enabled, unread, count } = useChatSummary();
</script>

<style scoped>
.chat-alert-row {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.75rem;
    color: var(--forkto-ink-1);
    text-decoration: none;
    border-bottom: 1px solid var(--forkto-line);
}
.chat-alert-row:hover {
    background: var(--forkto-sunk);
}
.chat-alert-row .chat-alert-mention {
    color: var(--forkto-unread);
    font-weight: 650;
}
.chat-alert-row span {
    color: var(--forkto-ink-3);
    font-size: 0.85rem;
    overflow-wrap: anywhere;
}
</style>
<style>
.chat-notifications-trigger.cell-popover-trigger {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.35rem;
    min-width: 44px;
    min-height: 44px;
    width: auto;
    flex: 0 0 auto;
    border: 1px solid transparent;
    border-radius: var(--forkto-radius-control);
    background: transparent;
    color: var(--forkto-ink-2);
}
</style>
